import { Copy, Lock } from "lucide-react";
import { ROLE_LABELS, type SessionResponse } from "@amber/access/contracts";
import { AppLink, Button, EmptyState, copyText, useToast } from "@amber/ui";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";

export function NoAccessPage({ what }: { what: string | undefined }) {
  usePageTitle("No access");
  return <AppFrame view="No access">{(session) => <NoAccess session={session} what={what} />}</AppFrame>;
}

function NoAccess({ session, what }: { session: SessionResponse; what: string | undefined }) {
  const toast = useToast();
  const admin = session.admins[0];
  const role = ROLE_LABELS[session.user.role];
  const request = `Hello${admin ? ` ${admin.display_name}` : ""}, I (${session.user.display_name}, ${session.user.email}, ${role}) need access to ${what ? `${window.location.origin}${what}` : "a page in Amber"}. Could you check whether my role should include it?`;
  return (
    <EmptyState
      level={1}
      icon={<Lock />}
      title="You don't have access to this"
      actions={
        <>
          <Button
            onClick={() => {
              void copyText(request).then(() => {
                toast.show("Request copied");
              });
            }}
          >
            <Copy aria-hidden="true" />
            Copy request for an admin
          </Button>
          <AppLink href="/" className="inline-flex h-8 items-center px-2 font-strong text-link">
            Back to Home
          </AppLink>
        </>
      }
    >
      <p className="m-0">
        Your role is <b className="font-semibold text-fg">{role}</b>, which doesn&apos;t include{" "}
        {what ? <code className="font-mono text-md">{what}</code> : "this page"}.
      </p>
      {admin ? (
        <p className="m-0 mt-1.5">
          Ask an Admin, for example {admin.display_name} ({admin.email}).
        </p>
      ) : (
        <p className="m-0 mt-1.5">Ask an Admin of this workspace.</p>
      )}
    </EmptyState>
  );
}
